import { sqScalarRuntimeStore } from '@/core/core.stores';
import type { ITEM_TYPES } from '@/trendData/trendData.constants';

/**
 * Overlays the fetched values onto a scalar so readers see them alongside its config. Scalars with
 * no entry are returned as-is (identity preserved).
 */
export function withScalarValues<T extends { id: string; itemType: ITEM_TYPES.SCALAR }>(item: T): T {
  const values = sqScalarRuntimeStore.getState().values[item.id];
  return values ? { ...item, ...values } : item;
}
